import React from 'react';
import ButtonGeneral from '../buttons/ButtonGeneral';

interface NavigationButtonsProps {
    onBack: () => void;
    onNext: () => void;
    backText?: string;
    nextText?: string;
    isSubmitting?: boolean;
    disabled?: boolean;
    className?: string;
}

const NavigationButtons: React.FC<NavigationButtonsProps> = ({
    onBack,
    onNext,
    backText = 'Volver',
    nextText = 'Siguiente',
    isSubmitting = false,
    disabled = false,
    className = ''
}) => {
    return (
        <div className={`navigation-buttons ${className}`}>
            <ButtonGeneral
                onClick={onBack}
                title={backText}
                variant="outline"
                size="large"
            />
            <ButtonGeneral
                onClick={onNext}
                title={isSubmitting ? 'Enviando...' : nextText}
                variant="primary"
                size="large"
                disabled={disabled || isSubmitting}
                loading={isSubmitting}
            />
        </div>
    );
};

export default NavigationButtons;
